import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-risk-result-page',
  templateUrl: './risk-result-page.component.html',
  styleUrls: ['./risk-result-page.component.less']
})
export class RiskResultPageComponent implements OnInit {

  ngOnInit(): void {
  }
  
  goToConfirm(){

  }
}
